import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Link } from "react-router-dom";
import { getProductUrl } from "../utils/productUrl";

const cartItemText = {
  price: "Цена",
  color: "Боја",
  diameter: "Дијаметар",
  storage: "Меморија",
  total: "Вкупно",
  remove: "Избриши",
};

function CartItem({ product, deleteCartProduct, calculateTotalPrice }) {
  const [quantityN, setquantityN] = useState(product.quantity);

  useEffect(() => {
    let current = sessionStorage.getItem("cart");

    if (!current) {
      current = [];
    } else {
      current = JSON.parse(current);
    }

    const productIndex = current.findIndex((obj) => obj.id === product.id);

    if (productIndex === -1) {
      return;
    }

    current[productIndex].quantity = quantityN;
    sessionStorage.setItem("cart", JSON.stringify(current));
    calculateTotalPrice(current);
  }, [quantityN, product.id, calculateTotalPrice]);

  const increaseQuantity = () => {
    if (quantityN < 15) {
      setquantityN(quantityN + 1);
    }
  };

  const decreaseQuantity = () => {
    if (quantityN > 1) {
      setquantityN(quantityN - 1);
    }
  };

  const productLink = getProductUrl(product);

  const totalPP = quantityN * product.price;

  return (
    <article className="cart-card">
      <div className="cart-card__media">
        <img src={product.img} alt={product.title} />
      </div>

      <div className="cart-card__content">
        <div className="cart-card__copy">
          <Link to={productLink} className="links">
            <p className="cart-card__title">{product.title}</p>
          </Link>

          <div className="cart-card__meta">
            <p>
              <span>{cartItemText.price}</span>
              {parseFloat(product.price).toLocaleString("en")} ден.
            </p>
            {product.color ? (
              <p className="cart-card__color-meta">
                <span>{cartItemText.color}</span>
                <span
                  className="cart-card__color-swatch"
                  style={{ backgroundColor: product.color }}
                  aria-label={`Selected color ${product.color}`}
                ></span>
              </p>
            ) : null}
            {product.storage ? (
              <p>
                <span>
                  {product.title.includes("Watch")
                    ? cartItemText.diameter
                    : cartItemText.storage}
                </span>
                {product.storage}
              </p>
            ) : null}
          </div>
        </div>

        <div className="cart-card__controls">
          <div className="quantity__change cart-card__quantity">
            <button type="button" onClick={decreaseQuantity} aria-label="Decrease quantity">
              <RemoveIcon fontSize="small" />
            </button>
            <p>{quantityN}</p>
            <button type="button" onClick={increaseQuantity} aria-label="Increase quantity">
              <AddIcon fontSize="small" />
            </button>
          </div>

          <div className="cart-card__total">
            <span>{cartItemText.total}</span>
            <strong>{parseFloat(totalPP).toLocaleString("en")} ден.</strong>
          </div>

          <button
            type="button"
            className="cart-card__remove"
            onClick={() => deleteCartProduct(product.id)}
            aria-label="Remove from cart"
          >
            <DeleteOutlineIcon fontSize="small" />
            <span>{cartItemText.remove}</span>
          </button>
        </div>
      </div>
    </article>
  );
}

export default CartItem;
